import React, { Component } from 'react'
import { Button } from 'antd'
import ProposalSection from './ProposalSection'

class ProposalSections extends Component {
  renderSection = (section, index) => {
    const {
      handleDeleteSection,
      handleChangeSectionName,
      handleAddItem,
      handleDeleteItem,
      handleItemChange,
      moveItemRight,
      moveItemLeft,
      moveItemUp,
      moveItemDown,
      handleMoveSectionUp,
      handleMoveSectionDown,
      handleDuplicateSection
    } = this.props
    return (
      <ProposalSection
        key={section.id || section.tmpId}
        sectionId={section.id || section.tmpId}
        sectionIndex={index}
        section={section}
        handleChangeSectionName={handleChangeSectionName}
        handleDuplicateSection={handleDuplicateSection}
        handleDeleteSection={handleDeleteSection}
        handleAddItem={handleAddItem}
        handleDeleteItem={handleDeleteItem}
        handleItemChange={handleItemChange}
        moveItemRight={moveItemRight}
        moveItemLeft={moveItemLeft}
        moveItemUp={moveItemUp}
        moveItemDown={moveItemDown}
        handleMoveSectionUp={handleMoveSectionUp}
        handleMoveSectionDown={handleMoveSectionDown}
      />
    )
  }

  render() {
    const { dataStructure, handleAddSection } = this.props

    return (
      <div>
        <div className="row mt-3">
          <div className="col-6">
            <Button icon="plus" onClick={handleAddSection}>
              Add New Group
            </Button>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">{dataStructure && dataStructure.map(this.renderSection)}</div>
        </div>
      </div>
    )
  }
}

export default ProposalSections



// WEBPACK FOOTER //
// ./src/components/ProposalSections.js